import ENV from "../config"

export const BASE_URL = ENV.DEV_URL

// export const BASE_URL = ENV.PROD_URL


// https://walletserver.greenlighttrust.com/walletservice
// export const BASE_URL = "https://walletserver.greenlighttrust.com/walletservice"

// Localhost base URL for QR generation
// export const LOCALHOST_BASE_URL = "http://3.131.122.117:5050"

// export const GEN_OFFER_BASE_URL = "http://localhost:5010"



// WebSocket Base URL
export const WS_BASE_URL = "wss://uatissue.glcredentials.com/walletservice"

// export const WS_BASE_URL = "wss://issue.glcredentials.com/walletservice/" //Prod

export default {
  pushData: {
    upload: `${BASE_URL}/upload-resource`,
  },
  signin: {
    auth: `${BASE_URL}/login`,
  },
  sendNotification: {
    notification: `${BASE_URL}/sendUserNotification`
  },
  sendAllNotification: {
    allUsers: `${BASE_URL}/api/v0.6/devices`
  },
  appConfiguration: {
    appConfig: `${BASE_URL}/career-wallet`,

  },
  generateOffer: {
    generateQR: `${BASE_URL}/claim-offer-qr`
  },
  batchIssuing: {
    runBatch: `${BASE_URL}/batch-issue`,
    wsUrl: `${WS_BASE_URL}/batch-issue-ws`,
    qrcodeUrl: `${BASE_URL}/batch-issue/qrcode`,
    byEmail: `${BASE_URL}/batch-issue/by-email`
    // byEmail: "http://localhost:5050/batch-issue/by-email"
    // byEmail: "http://18.191.70.156:5050/batch-issue/by-email"

  },
  createUser: {
    single: `${BASE_URL}/create-user`,
    bulk: `${BASE_URL}/bulk-upload-user`

    // single: "http://localhost:5050/create-user",
    // bulk: "http://localhost:5050/bulk-upload-user"
  },
  signup: {
    register: `${BASE_URL}/signin`
  },
  getUser: {
    byEmail: `${BASE_URL}/get-user-by-email`,
    all: `${BASE_URL}/get-all-users`
  }
};

// http://44.213.171.19:5015/getUser?page=2